import { jwtDecode } from 'jwt-decode';
// routes
// import { PATH_AUTH } from '../routes/paths';
//
import axios from './axios';

// ----------------------------------------------------------------------

const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }
  const decoded = jwtDecode(accessToken);

  const currentTime = Date.now() / 1000;

  if(decoded?.exp){
    return (decoded?.exp > currentTime)
  }else if(decoded?.iat > 0){
    return true;
  };
};

const handleTokenExpired = (exp) => {
  let expiredTimer;

  const currentTime = Date.now();

  // Test token expires after 10s
  // const timeLeft = currentTime + 10000 - currentTime; // ~10s
  const timeLeft = exp * 1000 - currentTime;

  clearTimeout(expiredTimer);

  expiredTimer = setTimeout(() => {
    // eslint-disable-next-line no-alert
    alert('Token expired');

    localStorage.removeItem('accessToken');

    // window.location.href = PATH_AUTH.login;
  }, timeLeft);
};

const setSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem('accessToken', accessToken);
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

    // This function below will handle when token is expired
    const { exp } = jwtDecode(accessToken); // ~5 days by minimals server
    if(exp){
      handleTokenExpired(exp);
    }
  } else {
    localStorage.removeItem('accessToken');
    delete axios.defaults.headers.common.Authorization;
  }
};

const getSession = () => {
  let userData;
  try {
    const accessToken = localStorage.getItem('accessToken');
    userData = decodeJWT(accessToken)
  } catch (error) {
    console.log("GET SESSION ERROR" , error);
  }
  return userData;
};

const decodeJWT = (accessToken) => {
  try {
    // const payload = accessToken.split('.');
    // console.log("payload",payload);
    // const user = JSON.parse(atob(payload[1]));
    // console.log("user",user);
    // return user;
    if(accessToken){
      const b64url = accessToken.replace(/^Bearer\s+/i, "").split(".")[1];
      if (!b64url) throw new Error("Not a JWT");
  
      const b64 = b64url.replace(/-/g, "+").replace(/_/g, "/");
      const padded = b64 + "=".repeat((4 - (b64.length % 4)) % 4);
  
      // bytes -> UTF-8 string
      const bytes = Uint8Array.from(atob(padded), c => c.charCodeAt(0));
      const jsonStr = new TextDecoder("utf-8").decode(bytes);
  
      return JSON.parse(jsonStr);
    }else{
      console.log("NO TOKEN");
      return null;
    }

  } catch (error) {
    console.log(error);
    return null
  }
}

export { isValidToken, setSession, decodeJWT , getSession };
